import { Dialog } from "vant";

/* global __APP_BUILD_ID__ */
const style = document.createElement("style");
style.textContent = `
  /* 弹窗根容器样式：大圆角、白色背景、内边距 */
  .custom-version-dialog {
    width: 14.7rem;
    height: 13.6rem;
    border-radius: 25px !important;
    background: #ffffff !important;
    padding: 30px 38px 20px !important;
  }

  /* 隐藏Vant默认的标题栏和按钮栏，完全自定义UI */
  .custom-version-dialog .van-dialog__title,
  .custom-version-dialog .van-dialog__footer {
    display: none !important;
  }

  /* 内容区通用样式：居中对齐 */
  .version-dialog-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* 铃铛图标样式：大小、间距 */
  .version-dialog-bell {
    width: 48px;
    height: 56px;
    margin-bottom: 20px;
  }

  .custom-version-dialog .van-dialog__message{
    padding: 0 !important;
    white-space: nowrap !important;
  }

  /* 标题样式：字体、颜色、间距 */
  .version-dialog-title {
    font-size:20px;
    font-weight: bold;
    color: #1D1D1D;
    margin-bottom: 23px;
  }

  /* 按钮通用样式：全宽、大圆角、点击反馈 */
  .version-dialog-btn {
    width: 198px;
    height: 40px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    border: none;
    margin-bottom: 12px;
    text-align: center;
    line-height: 40px;
  }
  .version-dialog-btn:active {
    opacity: 0.8; /* 点击变暗反馈 */
  }

  /* 立即刷新按钮：青绿色背景+白字 */
  .version-dialog-btn-primary {
    background: linear-gradient( 270deg, #6714CC 0%, #286FF8 100%) !important;
    color: #ffffff !important;
  }

  /* 暂不更新按钮：白底+黑框+灰字 */
  .version-dialog-btn-default {
    background: #ffffff !important;
    color: #1D1D1D !important;
    border: 1px solid #1D1D1D !important;
  }
`;
document.head.appendChild(style);

const POLL_MS = 60 * 1000;
const DISMISS_COOLDOWN_MS = 10 * 60 * 1000;

function versionJsonUrl() {
  const base = process.env.BASE_URL || "/";
  return new URL("version.json", window.location.origin + base).href;
}

/**
 * 生产环境：轮询线上 version.json，与当前页面构建 ID 不一致时提示刷新。
 */
export function startVersionCheck() {
  if (process.env.NODE_ENV !== "production") return;

  const localVersion =
    typeof __APP_BUILD_ID__ !== "undefined" ? __APP_BUILD_ID__ : "";
  if (!localVersion) return;

  let dialogOpen = false;
  let promptCooldownUntil = 0;

  const check = async () => {
    if (dialogOpen || Date.now() < promptCooldownUntil) return;
    try {
      const res = await fetch(`${versionJsonUrl()}?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;
      const data = await res.json();
      const remote = data && data.version != null ? String(data.version) : "";
      if (!remote || remote === localVersion) return;

      dialogOpen = true;
      Dialog.confirm({
        title: "",
        allowHtml: true, // 必须开启：支持SVG/HTML/按钮
        className: "custom-version-dialog", // 绑定自定义样式类
        message: `
        <div class="version-dialog-content">
          <img src="${require('@/assets/user/xiaoxi.png')}" class="version-dialog-bell" alt=""/>

          <div class="version-dialog-title">发现新版本</div>

          <button 
            class="version-dialog-btn version-dialog-btn-primary"
            onclick="window.__versionDialogRefresh()"
          >
            立即刷新
          </button>

          <button 
            class="version-dialog-btn version-dialog-btn-default"
            onclick="window.__versionDialogLater()"
          >
            暂不更新
          </button>
        </div>
      `,
      });

      window.__versionDialogRefresh = () => {
        Dialog.close(); // 关闭弹窗
        window.location.reload(); // 刷新页面
      };

      window.__versionDialogLater = () => {
        Dialog.close(); // 关闭弹窗
        promptCooldownUntil = Date.now() + DISMISS_COOLDOWN_MS; // 保留原冷却逻辑
        dialogOpen = false; // 重置弹窗状态
      };

      // 🔥 弹窗关闭后兜底重置状态（防止异常卡住）
      Dialog.closeFinished(() => {
        dialogOpen = false;
      });
    } catch (_) {
      // 网络异常时忽略，下次轮询再试
      dialogOpen = false; // 异常时重置状态
    }
  };

  setTimeout(check, 30 * 1000);
  setInterval(check, POLL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
  window.addEventListener("focus", check);
}
